import { useCallback, useEffect, useState } from 'preact/hooks';

import { useStompClient } from 'react-stomp-hooks';

export const useStompTokenAutoRefresh = () => {
  const stompClient = useStompClient();
  const [isConnecting, setIsConnecting] = useState(false);

  const handleReconnect = useCallback(() => {
    if (isConnecting) {
      return;
    }

    setIsConnecting(true);

    try {
      // Разрываем соединение, если оно активно
      if (stompClient && stompClient.connected) {
        stompClient.deactivate();
      }
    } catch (error: unknown) {
      if (typeof error === 'string') {
        throw new Error(error);
      }
    } finally {
      setIsConnecting(false);
    }
  }, [isConnecting, stompClient]);

  useEffect(() => {
    if (!stompClient) {
      return;
    }

    const onWebSocketClose = () => {
      // Обрабатываем неожиданные обрывы соединения
      handleReconnect();
    };

    stompClient.onWebSocketClose = onWebSocketClose;

    return () => {
      stompClient.onWebSocketClose = () => null;
    };
  }, [stompClient, handleReconnect]);
};
